<template>
  <ToastModal
    ref="modal"
    show-mobile-footer
    modal-id="TermsAndConditionsModal"
    :width="800"
    :title="$t('TermsAndConditions.Content.Title')"
  >
    <div class="pt-5 md:pt-12" />
    <TermsAndConditionsComponent />
    <template v-slot:footer>
      <ToastModalFooter class="w-full" color="black" variant="outline" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import TermsAndConditionsComponent from '@/components/TermsAndConditionsComponent'

export default {
  name: 'TermsAndConditionsModal',
  components: {
    ToastModal,
    TermsAndConditionsComponent,
    ToastModalFooter
  },
  methods: {
    toggleActivation (isOpen = true) {
      this.$refs.modal.toggleActivation(isOpen)
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style scoped lang="postcss">
>>> .terms-and-conditions-component {
  &-subject-title {
    @apply hidden;
  }
}
</style>
